import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { getLinkedAccounts } from 'bundles/third-party-auth/actions/AccountLinkActions';
import AccountLinkApple from 'bundles/third-party-auth/components/AccountLinkApple';
import AccountLinkFacebook from 'bundles/third-party-auth/components/AccountLinkFacebook';
import AccountLinkGoogle from 'bundles/third-party-auth/components/AccountLinkGoogle';
import AccountLinkSSO from 'bundles/third-party-auth/components/AccountLinkSSO';
import AccountLinkSlack from 'bundles/third-party-auth/components/AccountLinkSlack';
import AccountLinkZoom from 'bundles/third-party-auth/components/AccountLinkZoom';

import 'css!./__styles__/AccountLink';

class AccountLink extends React.Component {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof AccountLink.contextTypes>;

  componentDidMount() {
    this.context.executeAction(getLinkedAccounts);
  }

  render() {
    return (
      <div>
        <AccountLinkFacebook />
        <AccountLinkApple />
        <AccountLinkGoogle />
        <AccountLinkSSO />
        <AccountLinkZoom />
        <AccountLinkSlack />
      </div>
    );
  }
}

export default AccountLink;
